import settingRoutes from "./settingRoutes";

function routersConfig() {
  // * 引入模块/////////////

  const SignUpHouse = () => import("../pages/storeHouse/signUp");
  const OrderList = () => import("../pages/storeHouse/list");
  const aftersales = () => import("../pages/orderManagement/aftersales/list");
  const ShopList = () => import("../pages/myShops/list");
  const Goods = () => import("../pages/myShops/goods");
  const GoodsDetail = () => import("../pages/myShops/goods/detail");

  const HandleProduct = () => import("../pages/orderManagement/handle");
  const AddOrder = () => import("../pages/orderManagement/handle/createOrder");
  const OrderProcessing = () =>
    import("../pages/orderManagement/orderProcessing");
  const BagList = () => import("../pages/orderManagement/bagList");
  // 财务管理
  const Finances = () => import("../pages/financialManagement/finances");
  const RechargeRecord = () => import("../pages/financialManagement/record");
  const BillDetails = () => import("../pages/financialManagement/details");
  const Potential = () => import("../pages/financialManagement/potential");
  // * 路由树/////////////
  const WareHouseList = () => import("../pages/warehouse");
  // 注意： 路由路径必须延展父母节点，如：parentPath： a/b  childrenPath: a/b/c/d/e 这种形式，不然无法展开当前路由菜单

  const ProductsList = () => import("../pages/myProducts/list");
  const ProductsRemain = () => import("../pages/myProducts/remain");
  const BuyOfProducts = () => import("../pages/myProducts/buy");
  const ProductsDetail = () => import("../pages/myProducts/buy/detail");

  // 推荐份佣金
  const Affiliate = () => import("../pages/affiliate");

  // 教程
  const Tutorial = () => import("../pages/layout/Tutorial");

  const Summary = () => import("../pages/layout/summary");

  // 产品
  const HotProduct = () => import("../pages/unifyProducts/hotProducts");
  const ImportList = () => import("../pages/unifyProducts/importList");

  const regulatoryGovernance = [
    {
      title: "Unify Products",
      name: "UnifyProducts",
      iconClassName: "ProfileFilled",
      showSider: true,
      path: "/unifyDrop/unifyProducts",
      children: [
        {
          title: "Hot Products",
          name: "HotProducts",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/unifyProducts/hotProduct",
          component: HotProduct,
        },
        {
          title: "Import List",
          name: "ImportList",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/unifyProducts/importList",
          component: ImportList,
        },
      ],
    },
    {
      title: "MyStores",
      iconClassName: "ShopFilled",
      showSider: true,
      path: "/unifyDrop/storehouse",
      children: [
        {
          title: "StoreList",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/myShop/list",
          component: ShopList,
          children: [
            // 详情
          ],
        },
        {
          title: "StoreProducts",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/myShop/goods",
          component: Goods,
          children: [
            {
              title: "ViewMatch",
              path: "/unifyDrop/myShop/goods/relative",
              component: GoodsDetail,
            },
          ],
        },
      ],
    },
    {
      title: "Orders",
      iconClassName: "TagFilled",
      showSider: true,
      path: "/unifyDrop/orderManagement",
      children: [
        {
          title: "ManualOrder",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/orderManagement/handle",
          component: HandleProduct,
          children: [
            // 详情
            {
              title: "New",
              path: "/unifyDrop/orderManagement/handle/add",
              component: AddOrder,
            },
          ],
        },
        {
          title: "OrderList",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/orderManagement/list",
          component: OrderList,
        },
        {
          title: "Aftersales",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/orderManagement/aftersales",
          component: aftersales,
        },
        {
          title: "OrdersProcessing",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/orderManagement/orderProcessing",
          component: OrderProcessing,
          children: [],
        },
        {
          title: "PackageList",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/orderManagement/baglist",
          component: BagList,
        },
      ],
    },
    {
      title: "MyProducts",
      iconClassName: "ContainerFilled",
      showSider: true,
      path: "/unifyDrop/myProducts",
      children: [
        {
          title: "ProductList",
          iconClassName: "dote",
          showSider: false,
          path: "/unifyDrop/myProducts/list",
          component: ProductsList,
          children: [],
        },
        {
          title: "ProductInventory",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/myProducts/remains",
          component: ProductsRemain,
        },
        {
          title: "PurchasingList",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/myProducts/buyList",
          component: BuyOfProducts,
          children: [
            // 详情
            {
              title: "商品详情",
              path: "/unifyDrop/myProducts/bugList/detail",
              component: ProductsDetail,
            },
          ],
        },
      ],
    },
    {
      title: "Finance",
      iconClassName: "AccountBookFilled",
      showSider: true,
      path: "/unifyDrop/financialManagement",
      children: [
        {
          title: "Finance",
          ename: "RechargeRecords",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/financialManagement/finances",
          component: Finances,
        },
        {
          title: "RechargeRecords",
          iconClassName: "dote",
          showSider: false,
          path: "/unifyDrop/financialManagement/record",
          component: RechargeRecord,
        },
        {
          title: "Affiliate",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/financialManagement/affiliate",
          component: Affiliate,
        },
        {
          title: "BillingDetails",
          iconClassName: "dote",
          showSider: false,
          path: "/unifyDrop/financialManagement/details",
          component: BillDetails,
        },
        {
          title: "Potential",
          iconClassName: "dote",
          showSider: true,
          path: "/unifyDrop/financialManagement/Potential",
          component: Potential,
        }
      ],
    },
    {
      title: "Affiliate",
      iconClassName: "IdcardFilled",
      showSider: true,
      path: "/unifyDrop/affiliate",
      children: [
        {
          title: "Affiliate",
          showSider: true,
          path: "/unifyDrop/affiliate/detail",
          component: Affiliate,
        },
      ],
    },
    {
      title: "Tutorial",
      iconClassName: "ReadFilled",
      showSider: true,
      path: "/unifyDrop/Tutorial",
      component: Tutorial
    },
    {
      title: "Summary",
      iconClassName: "DashboardFilled",
      showSider: true,
      path: "/unifyDrop/Summary",
      component: Summary
    },
    // { // 暂时屏蔽
    //   title: "仓库管理",
    //   iconClassName: "enterprise",
    //   showSider: true,
    //   path: "/unifyDrop/warehouse",
    //   children: [
    //     {
    //       title: "仓库列表",
    //       iconClassName: "dote",
    //       showSider: true,
    //       path: "/unifyDrop/warehouse/list",
    //       component: WareHouseList,
    //       children: [
    //       ],
    //     },
    //   ],
    // },
    ...settingRoutes,
  ];
  // # 路由树/////////////

  let routers = [
    {
      title: "首页",
      pathName: "unifyDrop",
      routers: regulatoryGovernance,
    },
  ];

  routers = routers.map((topMenu, index) => {
    // 递归过滤子菜单
    function loopRouters(subRouters) {
      return subRouters.map((item) => {
        const { children, ...others } = item;
        let newChildren = undefined;
        if (children) {
          newChildren = { children: loopRouters(children) };
        }
        return { ...newChildren, ...others };
      });
    }

    let { routers, ...otherItems } = topMenu;
    return { routers: loopRouters(routers), ...otherItems };
  });

  return routers;
}

export default routersConfig;

// 查找第一个有效的子路由
export function effectiveFirstSubRouter(subRouters = []) {
  for (const item of subRouters) {
    const { disabled, showSider, component, children } = item;
    if (!disabled && showSider && component) {
      return item;
    } else if (children?.length) {
      const isFind = effectiveFirstSubRouter(children);
      if (isFind) {
        return isFind;
      }
    }
  }
}
// 查找第一个有效有路由
export function effectiveFirstRouter(routes) {
  for (const item of Object.entries(routes)) {
    // 遍历获取路由分类树
    const { routers } = item[1];

    const route = effectiveFirstSubRouter(routers);
    if (route) {
      return route;
    }
  }
}
